import type { FlatNavItem } from "../shell/navConfig";
import type { RelatedSetting } from "./relatedCatalog";

export const SETTINGS_HUB_PATH = "/settings";

export type ResolvedSetting = RelatedSetting & {
  path: string;
  query?: string;
  /** the screen it opens on ("הגדרות והרשאות", "פרויקטים" …) */
  where: string;
  /** a settings-hub section: edited right inside the panel */
  inline: boolean;
  focus?: string;
  why?: string;
};

/** A catalog entry → where it opens for this user (null = the user has no access to it). */
export function resolveSetting(s: RelatedSetting, nav: FlatNavItem[]): ResolvedSetting | null {
  const t = s.target;
  const byKey = (key: string) => nav.find((n) => n.key === key);
  if (t.design) {
    return { ...s, path: "", where: "מראה ותצוגה", inline: true };
  }
  if (t.hub) {
    const hub = byKey("settings");
    if (!hub) return null;
    return { ...s, path: SETTINGS_HUB_PATH, query: `section=${t.hub}`, where: hub.label, inline: true };
  }
  if (t.path) {
    const screen = t.nav ? byKey(t.nav) : nav.find((n) => t.path === n.path);
    if (!screen) return null;
    return { ...s, path: t.path, query: t.query, where: screen.label, inline: false, focus: t.focus };
  }
  return null;
}

/** Hebrew-friendly search: quotes / geresh ignored, every word must appear. */
export const normSearch = (v: string) => String(v || "").replace(/["'״׳`]/g, "").toLowerCase();

export function matchesQuery(text: string, query: string): boolean {
  const hay = normSearch(text);
  return normSearch(query)
    .split(/\s+/)
    .filter(Boolean)
    .every((w) => hay.includes(w));
}
